export function readContent(data) {
  if (
    data &&
    typeof data === "object" &&
    !Array.isArray(data) &&
    Object.prototype.hasOwnProperty.call(data, "content")
  ) {
    return data.content;
  }
  return data;
}

export function asList(data) {
  const content = readContent(data);
  if (Array.isArray(content)) return content;
  if (content && typeof content === "object" && content._id != null) {
    return [content];
  }
  return [];
}

export function replaceById(list, item) {
  if (!item || item._id == null) return Array.isArray(list) ? list : [];
  const next = Array.isArray(list) ? list : [];
  const id = String(item._id);
  const index = next.findIndex((entry) => entry && String(entry._id) === id);
  if (index === -1) next.push(item);
  else next[index] = item;
  return next;
}
